class CollectionCategories {
  constructor() {
    this.init();
  }

  init() {
    this.categoryButtons = document.querySelectorAll('.category-item');
    this.productPanels = document.querySelectorAll('.products-panel');
    this.defaultPanel = document.querySelector('.default-collection-panel');

    this.toggleCategoryArrows();

    // Reset all categories and panels
    this.categoryButtons.forEach(button => button.classList.remove('active'));
    this.productPanels.forEach(panel => {
      panel.classList.remove('active');
      panel.style.display = 'none';
    });

    // Show default or first panel
    if (this.defaultPanel) {
      this.defaultPanel.classList.add('active');
      this.defaultPanel.style.display = 'block';
      this.initializeProgressBar(this.defaultPanel);
    } else if (this.categoryButtons.length > 0) {
      this.switchCategory(this.categoryButtons[0], true);
    }

    this.bindEvents();
    this.enableDragScroll();
  }

  scrollActiveButtonIntoView(button) {
    const container = button.closest('.categories-carousel');
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const scrollLeft =
      container.scrollLeft +
      (buttonRect.left + buttonRect.width / 2 - containerRect.left - containerRect.width / 2);

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth',
    });
  }

  enableDragScroll() {
    const container = document.querySelector('.categories-carousel');
    if (!container) return;

    // Let mobile/touch devices use native scrolling
    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    if (isTouch) {
      container.style.touchAction = 'pan-x'; // hint: horizontal pan only
      return;
    }

    // Desktop "click + drag" to scroll
    let isDown = false;
    let startX = 0;
    let startLeft = 0;

    container.addEventListener('mousedown', (e) => {
      isDown = true;
      container.classList.add('dragging');
      startX = e.clientX;
      startLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mouseup', () => {
      isDown = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.clientX - startX;
      container.scrollLeft = startLeft - dx;
    });
  }

  toggleCategoryArrows() {
    const carousel = document.querySelector('.categories-carousel');
    if (!carousel) return;

    const arrowPrev = carousel.querySelector('.splide__arrow--prev');
    const arrowNext = carousel.querySelector('.splide__arrow--next');
    if (!arrowPrev || !arrowNext) return;

    const totalCategories = carousel.querySelectorAll('.category-item').length;

    if (totalCategories > 6) {
      arrowPrev.style.display = 'flex';
      arrowNext.style.display = 'flex';
    } else {
      arrowPrev.style.display = 'none';
      arrowNext.style.display = 'none';
    }
  }

  bindEvents() {
    this.categoryButtons.forEach(button => {
      button.addEventListener('click', () => this.switchCategory(button));
    });
  }

  switchCategory(selectedButton, isInitialLoad = false) {
    this.categoryButtons.forEach(button => button.classList.remove('active'));
    selectedButton.classList.add('active');

    this.scrollActiveButtonIntoView(selectedButton);

    this.productPanels.forEach(panel => {
      panel.classList.remove('active');
      panel.style.display = 'none';
    });

    const targetPanel = document.querySelector(
      `[data-category-panel="${selectedButton.dataset.category}"]`
    );

    if (targetPanel) {
      targetPanel.classList.add('active');
      targetPanel.style.display = 'block';
    } else {
      console.warn("No matching panel for:", selectedButton.dataset.category);
      return;
    }

    const carousel = targetPanel.querySelector('.splide');
    if (carousel?.splide) {
      carousel.splide.refresh();
    }

    this.initializeProgressBar(targetPanel);

    if (!isInitialLoad) {
      this.scrollToSection();
    }
  }

  /** ✅ Modified Progress bar logic with visible cards calculation */
  initializeProgressBar(panel) {
    if (!panel) return;

    const carouselComponent = panel.querySelector('carousel-component');
    if (!carouselComponent) return;

    const existingProgressBar = panel.querySelector('.collection-progress-bar');
    if (existingProgressBar) existingProgressBar.remove();

    const progressBarContainer = document.createElement('div');
    progressBarContainer.className = 'collection-progress-bar';
    const progressBarFill = document.createElement('div');
    progressBarFill.className = 'collection-progress-fill';
    progressBarContainer.appendChild(progressBarFill);

    const productsCarousel = panel.querySelector('.products-carousel');
    if (productsCarousel) {
      productsCarousel.parentNode.insertBefore(progressBarContainer, productsCarousel.nextSibling);
    } else {
      carouselComponent.parentNode.insertBefore(progressBarContainer, carouselComponent.nextSibling);
    }

    const updateProgress = () => {
      const track = carouselComponent.querySelector('.splide__track');
      const list = carouselComponent.querySelector('.splide__list');
      const slides = carouselComponent.querySelectorAll('.splide__slide');

      if (!track || !list || slides.length === 0) {
        progressBarContainer.style.display = 'none';
        return;
      }

      // Get total slides
      const totalSlides = slides.length;

      // Calculate visible slides based on viewport
      const trackWidth = track.offsetWidth;
      const slideWidth = slides[0].offsetWidth;
      const visibleSlides = Math.floor(trackWidth / slideWidth);

      // If all slides are visible, hide progress bar or show 100%
      if (visibleSlides >= totalSlides) {
        progressBarFill.style.width = '100%';
        return;
      }

      // Calculate current scroll position
      const transform = list.style.transform;
      let translateX = 0;
      if (transform && transform.includes('translateX')) {
        const match = transform.match(/translateX\(([^)]+)px\)/);
        if (match) translateX = Math.abs(parseFloat(match[1]));
      }

      // Calculate max scroll distance
      const maxScroll = list.scrollWidth - track.offsetWidth;

      // Calculate progress: from 0 to maxScroll maps to visibleSlides/totalSlides to 100%
      const startProgress = (visibleSlides / totalSlides) * 100;
      const remainingProgress = 100 - startProgress;

      if (maxScroll > 0) {
        const scrollProgress = (translateX / maxScroll) * remainingProgress;
        const totalProgress = startProgress + scrollProgress;
        progressBarFill.style.width = `${Math.min(100, totalProgress)}%`;
      } else {
        progressBarFill.style.width = `${startProgress}%`;
      }
    };

    const list = carouselComponent.querySelector('.splide__list');
    if (list) {
      const observer = new MutationObserver(() => setTimeout(updateProgress, 50));
      observer.observe(list, { attributes: true, attributeFilter: ['style'] });
    }

    const splideInstance = carouselComponent.querySelector('.splide')?.splide;
    if (splideInstance) {
      splideInstance.on('moved', updateProgress);
      splideInstance.on('scroll', updateProgress);
    }

    window.addEventListener('resize', () => setTimeout(updateProgress, 100));
    setTimeout(updateProgress, 500);
  }

  scrollToSection() {
    const element = document.querySelector('.collection-categories-section');
    if (element) {
      const rect = element.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const middle = top + rect.height;
      const scrollPos = middle - window.innerHeight;
      window.scrollTo({ top: scrollPos, behavior: 'smooth' });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionCategories();
});

window.addEventListener('resize', () => {
  const progressBars = document.querySelectorAll('.progress-bar');
  progressBars.forEach(bar => {
    if (window.innerWidth <= 768) bar.style.maxWidth = '344px';
    else bar.style.maxWidth = '500px';
  });
});